export const contractAddresses = {
    ethereum: {
        usdt: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
    },
    polygon: {
        usdt: '0xc2132D05D31c914a87C6611C10748AEb04B58e8F',
        ddp: process.env.REACT_APP_DDP_POLYGON_CONTRACT_ADDRESS || '0x',
        nrs: process.env.REACT_APP_NRS_POLYGON_CONTRACT_ADDRESS || '0x',
        veNrs: process.env.REACT_APP_VE_NRS_POLYGON_CONTRACT_ADDRESS || '0x',
        nrsRewardController: process.env.REACT_APP_NRS_REWARD_CONTROLLER_POLYGON_CONTRACT_ADDRESS || '0x',
        nrsWithdrawalTimelock: process.env.REACT_APP_NRS_WITHDRAWAL_TIMELOCK_POLYGON_CONTRACT_ADDRESS || '0x'
    }
};

export const tokenDecimals = {
    usdt: 6,
    nrs: 18,
    veNrs: 18
};
